import { render, staticRenderFns } from "./trainingitemsdata.vue?vue&type=template&id=15951936&scoped=true"
import script from "./trainingitemsdata.vue?vue&type=script&lang=js"
export * from "./trainingitemsdata.vue?vue&type=script&lang=js"
import style0 from "./trainingitemsdata.vue?vue&type=style&index=0&id=15951936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15951936",
  null
  
)

export default component.exports